// Mirror of backend/constants/insightQuestions.js — keep in sync.
//
// The questions the team asks every week, taken from their own meeting note.
// The id is what gets stored; the label is display only, so rewording a
// question never needs a migration.
//
// `unfiled` is deliberately NOT listed as a question. It is a valid storage key
// holding answers migrated from the old flat columns, whose question is not
// known. The UI renders it under "Not filed against a question" so nobody
// mistakes it for an answer to something specific.
export const INSIGHT_QUESTIONS = {
  rr: [
    { id: 'appointments',   label: 'How many client appointments involved future planning or repeat orders this week?' },
    { id: 'collaborations', label: 'How many partnership collaborations have you sent this month?' },
    { id: 'everyday',       label: 'Everyday catering' },
  ],
  market: [
    { id: 'event_types',   label: 'What types of events are most clients planning recently?' },
    { id: 'capture_ideas', label: 'What idea can you suggest to capture more market sales?' },
    { id: 'potential_customers', label: 'Who are your potential customers this month?' },
  ],
  challenges: [
    { id: 'support_needed', label: 'Any resources or assistance to boost your upcoming sales?' },
  ],
};

export const UNFILED = 'unfiled';

export const QUESTION_IDS = new Set([
  ...Object.values(INSIGHT_QUESTIONS).flat().map(q => q.id),
  UNFILED,
]);
